import classNames from 'clsx';
import React from 'react';

import { useWidget } from '@swf/core/hooks/useWidget';
import type { CasinoGame } from '@swf/core/types/CasinoGame';
import { PlayType } from '@swf/core/types/CasinoGame';

import styles from './CasinoPlaySelectorSL.scss';
import type { Props as PlayButtonPros } from './PlayButton/PlayButton';
import PlayButton from './PlayButton/PlayButton';
import RoundPlayButton from './RoundPlayButton/RoundPlayButton';

export interface Props {
  className?: string;
  favouriteIcon?: JSX.Element;
  game?: CasinoGame;
  hover?: boolean;
  multiplayer?: boolean;
  onClick(playType?: PlayType): void;
  size?: PlayButtonPros['size'];
}

const CasinoPlaySelectorSL: React.FC<Props> = ({ className, game, multiplayer, ...rest }) => {
  const { widgetId } = useWidget();
  const { name } = game || {};

  const newProps = { ...rest, widgetId };

  return multiplayer ? (
    <div className={classNames(className, styles.multiPlayContainer)}>
      <PlayButton {...newProps} playType={PlayType.Single} />
      <PlayButton {...newProps} playType={PlayType.Multi} />
    </div>
  ) : (
    <RoundPlayButton className={className} title={name} onClick={() => rest.onClick()} />
  );
};

export default CasinoPlaySelectorSL;
